<template>
  <VLotCreate is-not-template />
</template>

<script setup>
import VLotCreate from '@/components/views/Lot/VLotCreate'
import { defineProps } from 'vue'

defineProps({
  titlePage: {
    type: String,
    required: false,
  },
})
</script>
